import {
  AddNCentralConfigInput,
  IntegrationCustomerMappingInput,
  NCentralConfigSchema,
  NCentralDeviceSchema,
  NcentralDeviceMappingInput,
  UpdateNcentralRemoteCredentialsInput,
} from "shared/types/integrations";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";
import z from "zod";

const BASE_URL = import.meta.env.VITE_APP_INTEGRATION_BASE_URL;

export const getNcentralCustomers = async () => {
  try {
    const url = `${BASE_URL}/list-customers`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }

  // console.log(response.data);
};

export const getNcentralDevices = async () => {
  try {
    const url = `${BASE_URL}/list-devices`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      const data = NCentralDeviceSchema.parse(resData.data);
      return data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }

  // console.log(response.data);
};

export const addNcentralConfig = async ({
  webToken,
  baseUrl,
  board,
}: AddNCentralConfigInput) => {
  try {
    const url = `${BASE_URL}/ncentral/msp/configuration`;
    const data = {
      web_token: webToken,
      base_url: baseUrl,
      board,
      source_name: "ncentral",
    };
    const response = await axiosClient.post(`${url}`, data);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const updateNcentralConfig = async ({
  webToken,
  baseUrl,
  board,
}: AddNCentralConfigInput) => {
  try {
    const url = `${BASE_URL}/ncentral/msp/configuration`;
    const data = {
      web_token: webToken,
      base_url: baseUrl,
      board,
    };
    const response = await axiosClient.patch(`${url}`, data);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getNcentralConfig = async () => {
  try {
    const url = `${BASE_URL}/ncentral/msp/configuration`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }

  // console.log(response.data);
};

export const mapNcentralCustomers = async ({
  customerData,
  source,
}: IntegrationCustomerMappingInput) => {
  try {
    const url = `${BASE_URL}/mapped-customers/${source}`;
    const data = {
      customers: customerData,
    };
    const response = await axiosClient.post(`${url}`, data);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const mapNcentralDevices = async ({
  deviceMapping,
  source,
}: NcentralDeviceMappingInput) => {
  try {
    const url = `${BASE_URL}/mapped-devices/${source}`;
    const data = {
      device_mapping: deviceMapping,
    };
    const response = await axiosClient.post(`${url}`, data);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getIntegrationMappedDevices = async (source: string) => {
  try {
    const url = `${BASE_URL}/list/mapped-devices/${source}`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      // const data = NCentralConfigSchema.parse(resData.data);
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }

  // console.log(response.data);
};

export const updateNcentralRemoteCredentials = async ({
  username,
  password,
}: UpdateNcentralRemoteCredentialsInput) => {
  try {
    const url = `${BASE_URL}/v1/integration/ncentral/credentials`;
    const data = {
      username,
      password,
    };
    const response = await axiosClient.patch(`${url}`, data);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getNcentralRemoteCredentials = async () => {
  try {
    const url = `${BASE_URL}/v1/integration/ncentral/credentials`;
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    //  TODO: add statusCode check
    if (resData.success && resData.statusCode === 200) {
      // const data = NCentralConfigSchema.parse(resData.data);
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }

  // console.log(response.data);
};
